// LocatPage.tsx
import React, { FC, useCallback, useEffect, useState } from 'react'
import { Form, Formik, FormikProps } from 'formik'
import {
    ICouponDetailsModel,
    initialCoupon,
    tabOptions,
    validationCouponDetails,
    YES_OR_NO,
    STATUS_OPTIONS,
    CODE_TYPE_OPTIONS,
    CALCULATION_OPTIONS,
} from './CouponDetailsModel'
import {
    createCouponDetails,
    deleteCouponDetails,
    loadCouponDetails,
    updateCouponDetails,
} from './Api'
import { ConfirmModal } from '../../../../shared/components/ConfirmModal'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import FormTabHeader from '../../../../shared/components/FormTabHeader'
import TextInput from '../../../../shared/components/TextInput'
import SelectInput from '../../../../shared/components/SelectInput'
import CheckboxInput from '../../../../shared/components/CheckboxInput'
import { showErrorToast, showSuccessToast } from '../../../../shared/components/ToastUtils'

export const CouponDetailsPage: FC = () => {
    const [tab, setTab] = useState<string | 'form'>('form')
    const [loading, setLoading] = useState(false)
    const [selectedId, setSelectedId] = useState<string | null>(null)
    const [showModal, setShowModal] = useState(false)


    const handleSave = async (
        values: ICouponDetailsModel,
        resetForm: () => void
    ) => {
        setLoading(true)
        try {
            if (selectedId) {
                await updateCouponDetails({ ...values, id: selectedId })
                showSuccessToast('Kupon detay başarıyla güncellendi')
            } else {
                await createCouponDetails(values)
                showSuccessToast('Kupon detay başarıyla oluşturuldu')
            }
            resetForm()
            setSelectedId(null)
            setTab('form')
        } catch (err) {
            showErrorToast('Bir hata oluştu')
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async () => {
        if (selectedId) {
            try {
                await deleteCouponDetails(selectedId)
                showSuccessToast('Kupon detay başarıyla silindi')
            } catch (err) {
                console.error(err)
                showErrorToast('Kupon detay silinirken bir hata oluştu')
            } finally {
                setShowModal(false)
                setSelectedId(null)
            }
        }
    }

    return (
        <>
            <Formik
                initialValues={initialCoupon}
                validationSchema={validationCouponDetails}
                enableReinitialize
                onSubmit={(values, { resetForm }) => handleSave(values, resetForm)}
            >
                {(formik) => {
                    const handleReset = () => {
                        formik.resetForm()
                        setSelectedId(null)
                    }

                    return (
                        <>
                            <FormTabHeader
                                formId='couponForm'
                                formikSubmit={formik.handleSubmit}
                                formikReset={handleReset}
                                loading={loading}
                                tab={tab}
                                setTab={setTab}
                                setSelectedId={setSelectedId}
                                tabs={tabOptions}
                                onExportExcel={() => console.log('Excel export')}
                            />
                            <div className='card mb-5'>
                                <div className='card-body'>
                                    <Form id='couponForm' className='form'>
                                        {tab === 'form' && (
                                            <div className='row g-4'>
                                                {/* SOL TARAF */}
                                                <div className='col-md-6'>
                                                    <SelectInput name='status'
                                                        label='Durum'
                                                        options={STATUS_OPTIONS} />
                                                    <TextInput name='ruleName'
                                                        type='text'
                                                        label='Kural Adı' />

                                                    <TextInput name='rentalStartDate'
                                                        type='date'
                                                        label='Kira Baş. Tarih' />
                                                    <TextInput name='rentalEndDate'
                                                        type='date'
                                                        label='Kira Bit. Tarih' />

                                                    <TextInput name='requestStartDate'
                                                        type='date'
                                                        label='Talep Baş. Tarih' />
                                                    <TextInput name='requestEndDate'
                                                        type='date'
                                                        label='Talep Bit. Tarih' />

                                                    <CheckboxInput name='quickProcess'
                                                        label='Hızlı İşlem' />
                                                </div>

                                                {/* SAĞ TARAF */}
                                                <div className='col-md-6'>
                                                    <div className='row g-3'>
                                                        <TextInput name='minDays'
                                                            type='number'
                                                            label='Min Gün'
                                                            wrapperClassName='col-6' />
                                                        <TextInput name='maxDays'
                                                            type='number'
                                                            label='Max Gün'
                                                            wrapperClassName='col-6' />
                                                        <TextInput name='increaseDecrease'
                                                            type='number'
                                                            label='Artırma/İndirme'
                                                            wrapperClassName='col-6' />
                                                        <TextInput name='giftDays'
                                                            type='number'
                                                            label='Hediye Gün'
                                                            wrapperClassName='col-6' />
                                                    </div>

                                                    <SelectInput
                                                        name='dependentOnPromotionCode'
                                                        label='Promosyon Koduna Bağlı'
                                                        options={YES_OR_NO}
                                                    />
                                                    <TextInput name='promotionCode' type='text' label='Promosyon Kodu' />

                                                    <div className='row g-3'>
                                                        <SelectInput
                                                            name='codeType'
                                                            label='Kod Türü'
                                                            options={CODE_TYPE_OPTIONS}
                                                            wrapperClassName='col-6'
                                                        />
                                                        <SelectInput
                                                            name='calculation'
                                                            label='Hesaplama'
                                                            options={CALCULATION_OPTIONS}
                                                            wrapperClassName='col-6'
                                                        />
                                                    </div>
                                                </div>

                                                {/* GÜNLER */}
                                                <div className='col-12 mt-4'>
                                                    <div className='d-flex flex-wrap gap-4'>
                                                        <CheckboxInput name='monday'
                                                            label='Pazartesi' />
                                                        <CheckboxInput name='tuesday'
                                                            label='Salı' />
                                                        <CheckboxInput name='wednesday'
                                                            label='Çarşamba' />
                                                        <CheckboxInput name='thursday'
                                                            label='Perşembe' />
                                                        <CheckboxInput name='friday'
                                                            label='Cuma' />
                                                        <CheckboxInput name='saturday'
                                                            label='Cumartesi' />
                                                        <CheckboxInput name='sunday'
                                                            label='Pazar' />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Form>
                                </div>
                            </div>



                        </>
                    )
                }}
            </Formik >

            <ConfirmModal
                show={showModal}
                header='Silme Onayı'
                text='Bu kupon detayını silmek istediğinize emin misiniz?'
                handleClose={() => {
                    setShowModal(false)
                    setSelectedId(null)
                }}
                applyOnClick={handleDelete}
            />

            <ToastContainer
                position='top-right'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}
